import { render } from "./ProgramList.vue?vue&type=template&id=2fc74f20&scoped=true"
import script from "./ProgramList.vue?vue&type=script&lang=js"
export * from "./ProgramList.vue?vue&type=script&lang=js"

import "./ProgramList.vue?vue&type=style&index=0&id=2fc74f20&lang=scss"
import "./ProgramList.vue?vue&type=style&index=1&id=2fc74f20&scoped=true&lang=css"

import exportComponent from "/var/www/app/app-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc74f20"]])

export default __exports__